import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Events, useSubscribe } from "@/utils/conductor";
import { ref, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function selectRandomIdx(array: string[], previous: number) {
  let next = Math.floor(Math.random() * array.length);
  while (next === previous) {
    next = Math.floor(Math.random() * array.length);
  }
  return next;
}

// Background color
const THEMES = [
  "theme-blue",
  "theme-green",
  "theme-pink",
  "theme-gray",
  "theme-red",
  "theme-yellow",
  "theme-purple",
  "theme-black",
];
const colorIdx = ref(0);
useSubscribe(Events.rhodes, () => {
  colorIdx.value = selectRandomIdx(THEMES, colorIdx.value);
});
const colorTheme = computed(() => THEMES[colorIdx.value]);

// Font
const FONTS = [
  "font-leaguespartan",
  "font-oswald",
  "font-arista",
  "font-sporty",
  "font-bungee",
  "font-geosanslight",
  "font-uroob",
  "font-yrsa",
  "font-comic",
  "font-cheltenham",
];
const fontIdx = ref(0);
useSubscribe(Events.drums, () => {
  fontIdx.value = selectRandomIdx(FONTS, fontIdx.value);
});
const fontTheme = computed(() => FONTS[fontIdx.value]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`${_unref(colorTheme)} ${_unref(fontTheme)}`, "w-full h-full bg-primary"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})